import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY } from '../../AccountsWorkflowConstants';

const deleteAccount = (graphAccounts, id, workflowId, clientId) => (dispatch) => {
  dispatch(updateData(
    {
      [BACKEND_KEY]: graphAccounts.map((graphAccount) => {
        if (graphAccount.AccountId === id || graphAccount.frontEndId === id) {
          return {
            ...graphAccount,
            IsDeleted: true,
          };
        }
        return graphAccount;
      }),
    },
    workflowId,
    clientId,
  ));
};

export default deleteAccount;
